import React, { useState, useEffect, useCallback } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import { actionTypes, useStateValue } from "../../../store";
import Header from "../BaseComponents/Header";
import HIFotterMain from "../BaseComponents/Footer";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import parse from "html-react-parser";
import {
  BuyProductByCustomerOTPVerify,
  BuyProductByCustomerSendOTP,
  getCustomerProfile,
  getOEMProductDetails,
  HVPGetProductDetailsAPI,
  getCityList,
  getStateList,
  googleCaptchaAPIKey,
} from "../../../networkCalls";
import Box from "@mui/material/Box";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";

import LoadingCellFullPage from "../../LoadingCell/LoadingCellFullPage";
import ImageZoomCell from "./ImageZoomCell";
import SEO from "../../BaseComponents/SEO";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import {
  Autocomplete,
  FormControlLabel,
  FormGroup,
  TextField,
  useMediaQuery,
  Checkbox,
  Card,
  Typography,
} from "@mui/material";
import {
  CertifiedIcon,
  DeliveryIcon,
  GeniuneSpareIcon,
  WarrantyIcon,
} from "../BaseComponents/icon";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import ArrowForwardIosOutlinedIcon from "@mui/icons-material/ArrowForwardIosOutlined";
import * as yup from "yup";
import { Button, Modal } from "react-bootstrap";
import { useFormik } from "formik";
import CloseIcon from "@mui/icons-material/Close";
import ReCAPTCHA from "react-google-recaptcha";
import TurnRightRoundedIcon from '@mui/icons-material/TurnRightRounded';

const validationSchema1 = yup.object({
  name: yup.string().required("Name is required"),
  phone: yup.string().required("Phone Number is required"),
  email: yup.string().optional().email("Enter a valid email"),
  // pincode: yup.string().required("Pincode is required"),
  // city: yup.string().required("City is required"),
  // state: yup.string().required("State is required"),
});
const validationSchema2 = yup.object({
  otp: yup
    .string()
    .matches(/^[0-9]+$/, "Must be only digits")
    .length(6, "OTP must be 6 digits")
    .required("OTP is required"),
});
const HIValueProductDetails = () => {
  const [{ token, huid }, dispatch] = useStateValue();
  console.log("huid in product details", huid, token);
  const [value, setValue] = React.useState("1");
  const mediumViewport = useMediaQuery("(min-width:768px)");
  // const pathname = useLocation();
  const TEST_SITE_KEY = googleCaptchaAPIKey;
  const recaptchaRef = React.createRef();
  const [captchavalue, setCaptchavalue] = React.useState("");
  const onVerifyCaptcha = (captchavalue) => {
    setCaptchavalue(captchavalue);
  };
  // end capcha code

  const [agree, setAgree] = useState(false);
  const haveAgree = (event) => {
    setAgree(event.target.checked);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const location = useLocation();
  const { productSlug } = useParams();
  const [loading, setLoading] = useState(false);
  const [qtyCheck, setQtyCheck] = useState(false);
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
  const [slider1, setSlider1] = useState(null);
  const [slider2, setSlider2] = useState(null);
  // const [, dispatch] = useStateValue();

  useEffect(() => {
    setNav1(slider1);
    setNav2(slider2);
  });
  const settingsMain = {
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: true,
    arrows: false,
    infinite: false,
    asNavFor: nav2,
  };

  const settingsThumbs = {
    slidesToShow: 3,
    slidesToScroll: 1,
    swipeToSlide: true,
    focusOnSelect: true,
    arrows: true,
    infinite: false,
    asNavFor: nav1,
    centerPadding: "2px",
  };

  const [noProductFound, setNoProductFound] = useState(false);
  const [productDetails, setProductDetails] = useState("");
  const [productDetailsSpecification, setProductDetailsSpecification] =
    useState("");
  const [stateList, setStateList] = React.useState([]);
  const pullStateList = (value) => {
    var data = new FormData();
    data.append("countryId", "IND");
    getStateList(data).then((res) => {
      switch (res.data.status) {
        case 1:
          setStateList(res.data.stateList);
          return true;
        case 0:
          break;
        default:
          return;
      }
    });
  };
  const [state, setState] = useState("");
  const [stateName, setStateName] = useState("");
  const [cityList, setCityList] = React.useState([]);
  const pullCityList = (value) => {
    var data = new FormData();
    data.append("stateId", value);
    getCityList(data).then((res) => {
      switch (res.data.status) {
        case 1:
          setCityList(res.data.cityList);
          return true;
        case 0:
          break;
        default:
          return;
      }
    });
  };

  const stateChange = (e, value) => {
    setState(value?.id);
    pullCityList(value?.id);
    setStateName(value?.label);
  };
  const [city, setCity] = useState("");
  const cityChange = (e, value) => {
    setCity(value?.label);
  };
  const [customerData, setCustomerData] = React.useState(null);
  const [customerDataloaded, setCustomerDataLoaded] = React.useState(false);

  const callApiProfile = () => {
    var data = new FormData();
    data.append("customerId", huid);
    // data.append("XAuth", token);
    // setLoading(true);
    getCustomerProfile(data).then((res) => {
      console.log("getCustomerProfile", res);
      // setLoading(false);
      switch (res.data.status) {
        case 1:
          setCustomerData(res.data.customerData);
          setCustomerDataLoaded(true);
          return true;
        case 0:
          setErrMessage(res.data.msz);
          break;
        case 2:
          // dispatch({ type: actionTypes.SET_TOKENMODAL, value: true });
          break;
        default:
          return;
      }
    });
  };

  const pullProductData = () => {
    var data = new FormData();
    data.append("productSlug", productSlug);
    setLoading(true);
    HVPGetProductDetailsAPI(data).then((res) => {
      console.log("res getOEMProductDetails", res);
      setLoading(false);
      setNoProductFound(false);
      switch (res.data.status) {
        case 1:
          setProductDetails(res.data?.productsDetails);
          setProductDetailsSpecification(res.data?.productSpecification);
          return true;
        case 0:
          setNoProductFound(true);
          break;
        default:
          return;
      }
    });
  };

  useEffect(() => {
    setLoading(true);
    pullProductData();
    pullStateList();
  }, []);
  useEffect(() => {
    callApiProfile();
  }, [huid, token]);
  function priceDifference(price1, price2) {
    // Convert to numbers
    const num1 = parseFloat(price1);
    const num2 = parseFloat(price2);

    // Handle invalid numbers
    if (isNaN(num1) || isNaN(num2)) {
      console.log("Invalid price input. Please provide numeric strings.");
    }

    // Return absolute difference (always positive)
    return Math.abs(num1 - num2);
  }
  const getCompanyInitials = (name) => {
    if (!name) return "";
    const words = name.trim().split(/\s+/);
    const first = words[0]?.[0] || "";
    const second = words[1]?.[0] || "";
    return (first + second).toUpperCase();
  };
  const navigate = useNavigate();
  function navigateBAckPage() {
    navigate("/hi-value-plus/products");
  }
  // Modal details
  const [show, setShow] = useState(false);
  const [changetoOTP, setChangetoOTP] = useState(false);
  const [errMessage, setErrMessage] = useState("");
  const [susMessage, setSusMessage] = useState("");
  const [requestId, setRequestID] = useState("");

  const [Verificationshow, setVerificationShow] = useState(false);
  const [otpverificationresponse, setOTPverificationRespoanse] = useState("");

  const formikOtp = useFormik({
    enableReinitialize: true,
    initialValues: {
      name:
        customerData === null
          ? ""
          : `${customerData?.firstName} ${customerData?.lastName}`,
      phone: customerData === null ? "" : `${customerData?.phone}`,
      email: customerData === null ? "" : `${customerData?.email}`,
      pincode: "",
      state: "",
      city: "",
    },
    validationSchema: validationSchema1,
    onSubmit: (values) => {
      var data = new FormData();
      data.append("id", productDetails?.id);
      data.append("XAuth", token);
      data.append("name", values.name);
      data.append("phone", values.phone);
      data.append("email", values.email);
      data.append("zipcode", values.pincode);
      data.append("state", values.state);
      data.append("city", values.city);
      data.append("captcha", captchavalue); 
      // data.append("dealerList", JSON.stringify(dealer));
      // data.append("sellingId", sellingId);
      BuyProductByCustomerSendOTP(data).then((res) => {
        switch (res.data.status) {
          case 1:
            setErrMessage("");
            setSusMessage(res.data.msz);
            setRequestID(res.data.requestId);
            setChangetoOTP(true);

            return true;
          case 0:
            setErrMessage(res.data.msz);
            break;
          case 2:
            //  dispatch({ type: actionTypes.SET_TOKENMODAL, value: true });
            break;
          default:
            return;
        }
      });
    },
  });
  const formikOtpVerify = useFormik({
    enableReinitialize: true,
    initialValues: {
      otp: "",
    },
    validationSchema: validationSchema2,
    onSubmit: (values) => {
      console.log("values", values);
      var data = new FormData();
      data.append("customerId", huid);
      data.append("XAuth", token);
      data.append("otp", values.otp);
      data.append("requestId", requestId);
      BuyProductByCustomerOTPVerify(data).then((res) => {
        switch (res.data.status) {
          case 1:
            setErrMessage("");
            setSusMessage(res.data.msz);
            setOTPverificationRespoanse(res.data.msz);
            // setSellingId(res.data.sellingId);
            setChangetoOTP(false);
            setShow(false);
            setVerificationShow(true);

            // navigate("/myaccount/sell-your-product");

            return true;
          case 0:
            setErrMessage(res.data.msz);
            break;
          case 2:
            //  dispatch({ type: actionTypes.SET_TOKENMODAL, value: true });
            break;
          default:
            return;
        }
      });
      // setChangetoOTP(true);
    },
  });
  const handleClose = () => {
    setShow(false);
    setChangetoOTP(false);
  };
  const handleMapButtonClick = (value) => {
    const mapUrl = `https://www.google.com/maps/search/?api=1&query=${value}`; // Replace with your desired map URL
    window.open(mapUrl, "_blank", "noopener,noreferrer");
  };
  const enabledbtncapt = captchavalue != "" && agree;
  const [showConsent, setShowConsent] = useState(false);

  return (
    <>
      {/* <SEO
        title={productDetails?.productMetaTitle}
        description={productDetails?.productMetaDescriptopn}
        name="HIPP - Honda India Power"
        url={`https://www.hondaindiapower.com${location?.pathname}`}
        type="Website"
      /> */}
      <Header />
      <div className="hivalueplusproductlistcitystrip">
        <div className="d-flex gap-2 align-items-center container">
          <span className="d-flex align-items-center pointer">
            {" "}
            <span onClick={navigateBAckPage}>
              <ArrowBackOutlinedIcon /> Back to Products | Products{" "}
            </span>{" "}
            <ArrowForwardIosOutlinedIcon fontSize="12" />{" "}
            {productDetails?.productName}{" "}
          </span>
        </div>
      </div>
      <div id="hi-product-theme" className="hivalueplusproductlistmain">
        {loading ? (
          <>
            <LoadingCellFullPage />
          </>
        ) : (
          <>
            {noProductFound ? (
              <>
                <div>No Product Found</div>
              </>
            ) : (
              <>
                <div className=" pb-lg-5 pb-md-5  pb-2">
                  <div className="container hiproductdetailscontainer">
                    <div className="">
                      <div className="w-100">
                        <div className="w-100">
                          <div className="card mb-3  p-lg-4 p-md-4 p-3">
                            <div className="row">
                              <div className="col-12 d-block d-lg-none d-md-none">
                                <h3 className="txtdgray hivalueplusproductdetailsproductheading d-block d-lg-none d-md-none fw-bold mb-2  d-flex align-items-center align-items-lg-center align-items-md-center gap-2">
                                  {productDetails?.productName}{" "}
                                  <span className="hivalueplusproductdetailsproductheadingrefurbished txtlgeay fw-normal">
                                    (Refurbished Product)
                                  </span>
                                  <span className="hivalueplusproductdetailsproductheadingrefurbished txtlgeay fw-normal">
                                    Posted On : {productDetails?.postedOn}{" "}
                                  </span>
                                </h3>
                                <p className="txtlgeay d-flex d-block d-lg-none d-md-none  align-items-center hivalueplusproductdetailsproductheadingcategory mb-0 mt-lg-2 mt-md-2">
                                  {/* <LocationOnOutlinedIcon fontSize="small" />{" "} */}
                                  {productDetails?.categoryName}
                                </p>
                              </div>
                              <div className="col-lg-6 col-md-6 col-6 py-0 py-lg-4 py-md-4 ">

                                <div className="slider-wrapper hi-slider-wrapper">
                                  {/* MAIN SLIDER */}
                                  <Slider {...settingsMain} ref={(slider) => setSlider1(slider)}>
                                    {productDetails?.galleryImages?.map((slide, i) => (
                                      <ImageZoomCell key={i} slide={slide} />
                                    ))}
                                  </Slider>

                                  {/* THUMBNAILS */}
                                  {productDetails?.galleryImages?.length > 1 && (
                                    <div className="thumbnail-slider-wraps hi-thumb-wrap mt-1 mt-lg-3 mt-md-3">
                                      <Slider {...settingsThumbs} ref={(slider) => setSlider2(slider)}>
                                        {productDetails?.galleryImages?.map((slide, i) => (
                                          <div className=" p-lg-2 p-md-2  p-0 hi-thumb-frame" key={i}>
                                            <img
                                              src={`${slide.image}?img=${slide.id}`}
                                              alt=""
                                              className="img-fluid hi-thumb-image border rounded"
                                            />
                                          </div>
                                        ))}
                                      </Slider>
                                    </div>
                                  )}
                                </div>
                              </div>
                              <div className="col-lg-6 col-md-6 col-6 ps-0 pe-3 ps-md-4 pe-md-4 ps-lg-4 pe-lg-4">
                                <div className="pro_info mt-0 mt-lg-4 mt-md-4">
                                  <h3 className="txtdgray hivalueplusproductdetailsproductheading d-none d-lg-block d-md-block fw-bold mb-2 mt-4 d-flex align-items-center align-items-lg-center align-items-md-center gap-2">
                                    {productDetails?.productName}{" "}
                                    <span className="hivalueplusproductdetailsproductheadingrefurbished txtlgeay fw-normal">
                                      (Refurbished Product)
                                    </span>
                                    <span className="hivalueplusproductdetailsproductheadingrefurbished txtlgeay fw-normal ms-3">
                                    Posted On : {productDetails?.postedOn}{" "}
                                  </span>
                                  </h3>

                                  <p className="txtlgeay d-flex d-none d-lg-block d-md-block  align-items-center f14">
                                    {/* <LocationOnOutlinedIcon fontSize="small" />{" "} */}
                                    {productDetails?.categoryName}
                                  </p>
                                  <div className="hivalueplusproductdetailsbgDetails align-items-lg-center rounded p-2 p-lg-4 p-md-4 mb-1 mb-lg-3 mb-md-3 ">
                                    <div
                                      className={`d-flex   align-items-start align-items-lg-center align-items-md-center hivalueplusproductdetailsproductprice ${productDetails?.originalPrice === null
                                        ? "mb-0"
                                        : "mb-4"
                                        } fw-semibold`}
                                    >
                                      <div className="d-flex align-items-center">

                                        <CurrencyRupeeIcon className="fw-bold hivalueplusproductdetailsproductpricecurrency" />{" "}
                                        {productDetails?.price}{" "}
                                      </div>
                                      <p className="txtlgeay d-flex mb-0 ms-2 align-items-center hivalueplusproductdetailsproductheadingrefurbished">
                                        (inclusive of GST)
                                      </p>
                                    </div>
                                    {productDetails?.originalPrice !== null && (
                                      <p className="txtlgeay f17 mb-1">
                                        Original Honda retail price:{" "}
                                        <span className="text-decoration-line-through">
                                          {" "}
                                          ₹
                                          {
                                            productDetails?.originalPrice ===
                                              null
                                              ? productDetails?.price
                                              : productDetails?.originalPrice
                                          }
                                        </span>
                                      </p>
                                    )}
                                    {/* {productDetails?.originalPrice !== null && (
                                      <p className=" f17 mb-0">
                                        You save:{" "}
                                        <span className="">
                                          {" "}
                                          ₹
                                          {priceDifference(
                                            productDetails?.originalPrice ===
                                              null
                                              ? productDetails?.price
                                              : productDetails?.originalPrice,
                                            productDetails?.price
                                          )}
                                        </span>
                                      </p>
                                    )} */}
                                  </div>
                                  <div className="row g-3 mt-1 mt-lg-0 mt-md-0 mb-0 mb-lg-3 mb-md-3">
                                    <div className="col-12 col-lg-4 col-md-4 px-2  mt-1 mt-lg-2 mt-md-2">
                                      <div className="hivalueplusproductdetailsbgDetails rounded py-1 py-lg-3 py-md-3 px-lg-4 px-md-4 px-3 px-lg-4 px-md-4 mb-1 mb-lg-3 mb-md-3 d-flex align-items-center justify-content-start justify-content-lg-center justify-content-md-center flex-row flex-md-column flex-lg-column gap-2 gap-lg-0 gap-md-0">
                                        <WarrantyIcon className="hiicondetails" />
                                        <span className="hivalueplusproductdetailsproductheadingrefurbished fw-semibold text-center mt-0  mt-lg-3 mt-md-3">
                                          {productDetails?.warranty} months{" "}
                                          <br className="d-none d-lg-block d-md-block" />
                                          warranty
                                        </span>
                                      </div>
                                    </div>
                                    <div className="col-12 col-lg-4 col-md-4 px-2 mt-0 mt-lg-2 mt-md-2">
                                      <div className="hivalueplusproductdetailsbgDetails rounded py-1 py-lg-3 py-md-3 px-lg-4 px-md-4 px-3 px-lg-4 px-md-4  mb-1 mb-lg-3 mb-md-3 d-flex align-items-center justify-content-start justify-content-lg-center justify-content-md-center flex-row flex-md-column flex-lg-column gap-2 gap-lg-0 gap-md-0">
                                        <CertifiedIcon className="hiicondetails" />
                                        <span className="hivalueplusproductdetailsproductheadingrefurbished fw-semibold text-center mt-0  mt-lg-3 mt-md-3">
                                          Authorized Dealer Certified
                                        </span>
                                      </div>
                                    </div>
                                    <div className="col-12 col-lg-4 col-md-4 px-2  mt-0 mt-lg-2 mt-md-2">
                                      <div className="hivalueplusproductdetailsbgDetails rounded py-1 py-lg-3 py-md-3 px-lg-4 px-md-4 px-3 px-lg-4 px-md-4 mb-1 mb-lg-3 mb-md-3 d-flex align-items-center justify-content-start justify-content-lg-center justify-content-md-center flex-row flex-md-column flex-lg-column gap-1 gap-lg-0 gap-md-0">
                                        <GeniuneSpareIcon className="hiicondetails" />
                                        <span className="hivalueplusproductdetailsproductheadingrefurbished fw-semibold mt-0  mt-lg-3 mt-md-3 mb-0  mb-lg-3 mb-md-3 ">
                                          Genuine spares
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                  <div className=" d-none d-lg-block d-md-block">


                                    <div className="border rounded p-3 mb-3">
                                      <div className="d-flex flex-column flex-lg-row flex-md-row  justify-content-between mb-3">
                                        <div>
                                          <p className="hivalueplusproductdetailsdealerheading fw-semibold mb-1">
                                            HI Value<sup>+</sup> Authorized Dealer
                                          </p>
                                          <p className="hivalueplusproductdetailsdealerdetails txtlgeay mb-0">
                                            Get in touch to purchase this product
                                          </p>
                                        </div>
                                        <div
                                          className="hivalueplussectionBtnsection mt-2 mt-lg-0 mt-md-0 d-flex justify-content-center align-items-center p-2"
                                          onClick={() => {
                                            console.log(
                                              "token is ",
                                              token,
                                              "typeof ",
                                              typeof token
                                            );
                                            // if (!token) {
                                            //   console.log(
                                            //     "token is",
                                            //     token,
                                            //     typeof token
                                            //   );
                                            //   dispatch({
                                            //     type: actionTypes.SET_LOGINMODAL,
                                            //     value: true,
                                            //   });
                                            // } else {
                                            setShow(true);
                                            // }
                                          }}
                                        >
                                          Enquire Now
                                        </div>
                                      </div>
                                      <div className="d-flex align-items-center " >
                                        {" "}
                                        <span className="rounded-circle bg-black text-white d-flex justify-content-center align-content-center f10 px-1 me-2">
                                          {getCompanyInitials(
                                            productDetails?.dealerName
                                          )}
                                        </span>{" "}
                                        {productDetails?.dealerName}
                                      </div>
                                      <div className="d-flex flex-column flex-lg-row flex-md-row align-items-start align-items-lg-center align-items-md-center gap-2 mt-2">

                                        <Link
                                          to={`https://www.google.com/maps/search/?api=1&query=${productDetails?.mapLocation}`}
                                          target="_blank"
                                          className="txtlgeay d-flex align-items-center f12 "
                                        >
                                          <LocationOnOutlinedIcon fontSize="small" />{" "}
                                          {productDetails?.city},
                                          {productDetails?.state}
                                        </Link>
                                        <Link to={`https://www.google.com/maps/search/?api=1&query=${productDetails?.mapLocation}`}
                                          target="_blank" className="hivalueplussectionBtns rounded-pill mt-1 mt-lg-0 mt-md-0  d-flex justify-content-center gap-2 f10 align-items-center px-2 py-1"><TurnRightRoundedIcon /> Get Direction</Link>
                                      </div>
                                    </div>
                                    <div className="f16 fw-semibold">
                                      Short Description:
                                    </div>
                                    <p className="f13 txtlgeay">
                                      {productDetails?.shortDescription}
                                    </p>
                                  </div>
                                </div>

                                <div className="d-flex mt-2 align-items-center">
                                  <div className="d-none">
                                    {productDetails?.productBrandLogo ? (
                                      <>
                                        <img
                                          src={productDetails?.productBrandLogo}
                                          className="border p-1 me-2"
                                          style={{ width: "100px" }}
                                        />
                                      </>
                                    ) : (
                                      <></>
                                    )}
                                  </div>
                                  <div >{productDetails?.productWarranty}</div>
                                </div>
                                <div className="me-3 mt-0 table-responsive mb-3">
                                  <div className="product-general-info">
                                    {productDetails &&
                                      productDetails?.productHighlight?.length >
                                      0 &&
                                      productDetails?.productHighlight?.map(
                                        (itemin, key) => (
                                          <div
                                            className="single-general-info d-flex"
                                            key={key}
                                          >
                                            <div style={{ width: "32px" }}>
                                              {/* <img src={`${baseURL}images/no-charges.png`} style={{ width: '24px' }} alt="" /> */}
                                              <StarBorderIcon
                                                color="error"
                                                className="me-2"
                                              />
                                            </div>
                                            <div className="">
                                              <span className="fw-bold">
                                                {itemin?.label}
                                              </span>{" "}
                                              {itemin?.value}
                                            </div>
                                          </div>
                                        )
                                      )}
                                  </div>
                                </div>
                              </div>
                              <div className="col-12 col-lg-4 col-md-4 d-block d-lg-none d-md-none">


                                <div className="border rounded p-3 mb-3">
                                  <div className="d-flex flex-column flex-lg-row flex-md-row  justify-content-between mb-3">
                                    <div>
                                      <p className="hivalueplusproductdetailsdealerheading fw-semibold mb-1">
                                        HI Value<sup>+</sup> Authorized Dealer
                                      </p>
                                      <p className="hivalueplusproductdetailsdealerdetails txtlgeay mb-0">
                                        Get in touch to purchase this product
                                      </p>
                                    </div>
                                    <div
                                      className="hivalueplussectionBtnsection mt-2 mt-lg-0 mt-md-0 d-flex justify-content-center align-items-center p-2"
                                      onClick={() => {
                                        console.log(
                                          "token is ",
                                          token,
                                          "typeof ",
                                          typeof token
                                        );
                                        // if (!token) {
                                        //   console.log(
                                        //     "token is",
                                        //     token,
                                        //     typeof token
                                        //   );
                                        //   dispatch({
                                        //     type: actionTypes.SET_LOGINMODAL,
                                        //     value: true,
                                        //   });
                                        // } else {
                                        setShow(true);
                                        // }
                                      }}
                                    >
                                      Enquire Now
                                    </div>
                                  </div>
                                  <div className="d-flex align-items-center " >
                                    {" "}
                                    <span className="rounded-circle bg-black text-white d-flex justify-content-center align-content-center f10 px-1 me-2">
                                      {getCompanyInitials(
                                        productDetails?.dealerName
                                      )}
                                    </span>{" "}
                                    {productDetails?.dealerName}
                                  </div>
                                  <div className="d-flex flex-column flex-lg-row flex-md-row align-items-start align-items-lg-center align-items-md-center gap-2 mt-2">

                                    <Link
                                      to={`https://www.google.com/maps/search/?api=1&query=${productDetails?.mapLocation}`}
                                      target="_blank"
                                      className="txtlgeay d-flex align-items-center f12 "
                                    >
                                      <LocationOnOutlinedIcon fontSize="small" />{" "}
                                      {productDetails?.city},
                                      {productDetails?.state}
                                    </Link>
                                    <Link to={`https://www.google.com/maps/search/?api=1&query=${productDetails?.mapLocation}`}
                                      target="_blank" className="hivalueplussectionBtns rounded-pill mt-1 mt-lg-0 mt-md-0  d-flex justify-content-center gap-2 f10 align-items-center px-2 py-1"><TurnRightRoundedIcon /> Get Direction</Link>
                                  </div>
                                </div>
                                <div className="hivalueplusproductdetailsdealerheading fw-semibold">
                                  Short Description:
                                </div>
                                <p className="hivalueplusproductdetailsdealerdetails txtlgeay">
                                  {productDetails?.shortDescription}
                                </p>
                              </div>
                              <div className="col-sm-12 f14 my-2 my-lg-4 my-md-4">
                                <TabContext value={value}>
                                  <Box
                                    sx={{
                                      borderBottom: 1,
                                      borderColor: "divider",
                                    }}
                                  >
                                    <TabList
                                      onChange={handleChange}
                                      variant={
                                        mediumViewport ? "" : "scrollable"
                                      }
                                      scrollButtons="auto"
                                      allowScrollButtonsMobile
                                      //   centered={mediumViewport ? true : false}
                                      TabIndicatorProps={{
                                        style: {
                                          //display: "none",
                                          backgroundColor: "#00000",
                                        },
                                      }}
                                      aria-label=""
                                    >
                                      <Tab className="hidetailstabs_heading" label="Specification" value="1" />
                                      <Tab className="hidetailstabs_heading" label="Description" value="2" />
                                    </TabList>
                                  </Box>
                                  <TabPanel value="2" className="px-1 py-2 p-lg-auto p-md-auto">
                                    <div className="py-2 py-lg-3 py-md-3">
                                      {parse(`${productDetails?.description}`)}
                                    </div>
                                  </TabPanel>
                                  <TabPanel value="1" className="px-1 py-2 p-lg-auto p-md-auto">
                                    <div className="py-1 py-lg-3 py-md-3">
                                      {productDetailsSpecification?.length >
                                        0 ? (
                                        <>
                                          <div className="card mb-3">
                                            <h3 className="p-3 mb-0 hivalueplusproductdetailsSpecificationheading fw-bold">
                                              SPECIFICATIONS
                                            </h3>
                                            <hr className="mb-1 mt-0" />
                                            <div className="row">
                                              <div className="col-sm-12 f14">
                                                <div className="p-2 p-lg-3 p-md-3 ">
                                                  <div className="row">
                                                    <div className="col-sm-12"></div>
                                                    <div className="col-sm-12">
                                                      {productDetails &&
                                                        productDetailsSpecification.length >
                                                        0 &&
                                                        productDetailsSpecification?.map(
                                                          (itemin, key) => (
                                                            <div key={key}>
                                                              <div className="d-flex align-items-center mb-2">
                                                                {itemin?.image !=
                                                                  "" ? (
                                                                  <>
                                                                    <div className="me-2">
                                                                      <img
                                                                        src={
                                                                          itemin?.image
                                                                        }
                                                                        alt={
                                                                          itemin?.label
                                                                        }
                                                                        style={{
                                                                          maxWidth:
                                                                            "30px",
                                                                        }}
                                                                      />
                                                                    </div>
                                                                  </>
                                                                ) : null}
                                                                <div className="fw-bold hivalueplusproductdetailsSpecificationheading">
                                                                  {" "}
                                                                  <span className="text-black">
                                                                    {
                                                                      itemin?.label
                                                                    }
                                                                  </span>
                                                                </div>
                                                              </div>
                                                              <table className="table table-sm table-striped table-hover hivalueplusproductdetailsSpecificationdetails">
                                                                <tbody>
                                                                  {itemin?.list &&
                                                                    itemin?.list
                                                                      ?.length >
                                                                    0 &&
                                                                    itemin?.list?.map(
                                                                      (
                                                                        listitem,
                                                                        key
                                                                      ) => (
                                                                        <tr
                                                                          key={
                                                                            key
                                                                          }
                                                                        >
                                                                          <td className=" text-left w-50">
                                                                            {
                                                                              listitem?.label
                                                                            }
                                                                          </td>
                                                                          <td>
                                                                            {
                                                                              listitem?.value
                                                                            }
                                                                          </td>
                                                                        </tr>
                                                                      )
                                                                    )}
                                                                </tbody>
                                                              </table>
                                                              <hr />
                                                            </div>
                                                          )
                                                        )}
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </>
                                      ) : (
                                        <></>
                                      )}
                                    </div>
                                  </TabPanel>
                                </TabContext>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
            {/* <div style={{ clear: 'both', height: '40px' }}></div> */}
          </>
        )}
      </div>
      <Modal
        size="md"
        show={show}
        backdrop="static"
        keyboard={false}
        contentClassName="border-0 rounded-0"
        onHide={() => handleClose()}
        aria-labelledby="video-lg"
      >
        <Modal.Body className="p-0">
          <div
            onClick={() => handleClose()}
            aria-label="delete"
            size="small"
            className="position-absolute top-0 end-0 btn-out"
          >
            <CloseIcon fontSize="small" className="text-white" />
          </div>
          <div className="px-5 my-3 mx-5">
            <div className="row">
              <div className="col-12">
                <h4 className=" m-0 fw-bold text-uppercase text-center">
                  <span className="txtdgray">OTP Verification</span>
                </h4>
              </div>
              {changetoOTP ? (
                <form
                  className="col-12"
                  onSubmit={formikOtpVerify.handleSubmit}
                  autoComplete="off"
                >
                  <div>
                    <div className="mt-2">
                      <TextField
                        className="mb-4 w-100"
                        variant="standard"
                        id="otp"
                        name="otp"
                        label="Enter 6 digit code *"
                        type="text"
                        value={formikOtpVerify.values.otp}
                        onChange={formikOtpVerify.handleChange}
                        onBlur={formikOtpVerify.handleBlur}
                        error={
                          formikOtpVerify.touched.otp &&
                          Boolean(formikOtp.errors.otp)
                        }
                        helperText={
                          formikOtpVerify.touched.otp &&
                          formikOtpVerify.errors.otp
                        }
                      />
                    </div>
                  </div>
                  <div className="col-lg-12 col-12">
                    <div className="relative w-full mb-3">
                      <Button
                        variant="contained"
                        className="w-100 hivalueplusSubmitBtn"
                        type="submit"
                      // onClick={() => {
                      //   setShow(true);
                      // }}
                      >
                        Verify
                      </Button>
                    </div>
                  </div>
                </form>
              ) : (
                <form
                  className="col-12"
                  onSubmit={formikOtp.handleSubmit}
                  autoComplete="off"
                >
                  <div>
                    <div className="mt-3">
                      <TextField
                        className="mb-2 w-100"
                        variant="standard"
                        id="name"
                        name="name"
                        label="Your Name *"
                        type="text"
                        value={formikOtp.values.name}
                        onChange={formikOtp.handleChange}
                        onBlur={formikOtp.handleBlur}
                        error={
                          formikOtp.touched.name &&
                          Boolean(formikOtp.errors.name)
                        }
                        helperText={
                          formikOtp.touched.name && formikOtp.errors.name
                        }
                      />
                    </div>
                    <div className="">
                      <TextField
                        className="mb-2 w-100"
                        variant="standard"
                        id="phone"
                        name="phone"
                        label="Phone Number *"
                        type="text"
                        value={formikOtp.values.phone}
                        onChange={formikOtp.handleChange}
                        disabled={customerDataloaded}
                        onBlur={formikOtp.handleBlur}
                        error={
                          formikOtp.touched.phone &&
                          Boolean(formikOtp.errors.phone)
                        }
                        helperText={
                          formikOtp.touched.phone && formikOtp.errors.phone
                        }
                      />
                    </div>
                    <div className="">
                      <TextField
                        className="mb-2 w-100"
                        variant="standard"
                        id="email"
                        name="email"
                        label="Email"
                        type="text"
                        value={formikOtp.values.email}
                        onChange={formikOtp.handleChange}
                        onBlur={formikOtp.handleBlur}
                        error={
                          formikOtp.touched.email &&
                          Boolean(formikOtp.errors.email)
                        }
                        helperText={
                          formikOtp.touched.email && formikOtp.errors.email
                        }
                      />
                    </div>
                    {/* <div>
                      <Autocomplete
                        disablePortal
                        id="state"
                        className=" "
                        name="state"
                        options={stateList}
                        value={
                          stateList.find(
                            (opt) => opt.label === formikOtp.values.state
                          ) || null
                        }
                        onChange={(e, value) => {
                          console.log("selected state", value);
                          formikOtp.setFieldValue("state", value?.label || "");
                          pullCityList(value?.id);
                          //   setCityList([]);
                        }}
                        onBlur={() => formikOtp.setFieldTouched("state", true)}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="standard"
                            className="mb-2 w-100"
                            label="Select State"
                            error={
                              formikOtp.touched.state &&
                              Boolean(formikOtp.errors.state)
                            }
                            helperText={
                              formikOtp.touched.state && formikOtp.errors.state
                            }
                          />
                        )}
                      />
                    </div>
                    <div>
                      <Autocomplete
                        disablePortal
                        className=""
                        id="city"
                        name="city"
                        options={cityList}
                        value={
                          cityList.find(
                            (opt) => opt.label === formikOtp.values.city
                          ) || null
                        }
                        onChange={(e, value) => {
                          formikOtp.setFieldValue("city", value?.label || "");
                          // pullCityList(value?.label);
                          //   setCityList([]);
                        }}
                        onBlur={() => formikOtp.setFieldTouched("city", true)}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="standard"
                            className="mb-2 w-100"
                            label="Select city"
                            error={
                              formikOtp.touched.city &&
                              Boolean(formikOtp.errors.city)
                            }
                            helperText={
                              formikOtp.touched.city && formikOtp.errors.city
                            }
                          />
                        )}
                      />
                    </div>
                    <div className="">
                      <TextField
                        className="mb-2 w-100"
                        variant="standard"
                        id="pincode"
                        name="pincode"
                        label="Pincode *"
                        type="text"
                        value={formikOtp.values.pincode}
                        onChange={formikOtp.handleChange}
                        onBlur={formikOtp.handleBlur}
                        error={
                          formikOtp.touched.pincode &&
                          Boolean(formikOtp.errors.pincode)
                        }
                        helperText={
                          formikOtp.touched.pincode && formikOtp.errors.pincode
                        }
                      />
                    </div> */}
                    <div className="f12 mb-2">
                      <div className="d-flex align-items-center">
                        <div>
                          {" "}
                          <FormGroup>
                            <FormControlLabel
                              className="f14"
                              control={
                                <Checkbox
                                  className="f14"
                                  checked={agree}
                                  onChange={haveAgree}
                                />
                              }
                              label=""
                            />
                          </FormGroup>
                        </div>
                        <div className="f12">
                          I hereby consent to <span className="fw-bold">Honda India Power Products Ltd.</span> and its <span className="fw-bold">authorised dealers</span> collecting, processing, and using my personal data
                          {
                            showConsent && <>
                              <br />
                              <span>
                                (such as name, mobile number, email ID, and enquiry details) for the limited purpose of responding to my enquiry, sharing product information, facilitating buy/sell requests, and providing related assistance on the <span className="fw-bold">HI Value<sup>+</sup> platform.</span>
                                I understand that my personal data will be <span className="fw-bold">securely stored</span> and used strictly in accordance with Honda India Power Products Ltd.’s <span className="fw-bold">Privacy Notice</span> and applicable data protection laws. My data will be retained only for as long as necessary to fulfil the stated purpose or as required by law.
                                I am aware of my rights as a <span className="fw-bold">data principal</span>, including the right to access, correct, withdraw consent, or request deletion of my personal data at any time. I may withdraw my consent by contacting Honda India Power Products Ltd. through the details provided in the Privacy Policy.
                              </span>
                            </>
                          }
                          <span className="cursor-pointer linkblue fw-semibold" onClick={() => { setShowConsent(!showConsent) }}>{showConsent ? " ..See Less" : " ..See More"}</span>

                          {/* <Link to="/terms-of-use" target="_blank">
                            Terms & Privacy Policy
                          </Link> */}
                        </div>
                      </div>
                    </div>
                    <div className="col-12 mb-2">
                      <ReCAPTCHA
                        style={{ display: "inline-block" }}
                        theme="light"
                        ref={recaptchaRef}
                        sitekey={TEST_SITE_KEY}
                        onChange={onVerifyCaptcha}
                        onExpired={() => {
                          recaptchaRef.current.reset(); // here
                          setCaptchavalue("");
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-lg-12 col-12">
                    <div className="relative w-full mb-3">
                      <Button
                        variant="contained"
                        disabled={!enabledbtncapt}
                        className="w-100 hivalueplusSubmitBtn"
                        type="submit"
                      // onClick={() => {
                      //   setShow(true);
                      // }}
                      >
                        Get OTP
                      </Button>
                    </div>
                  </div>
                </form>
              )}
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        size="md"
        show={Verificationshow}
        backdrop="static"
        keyboard={false}
        contentClassName="border-0 rounded-0"
        onHide={() => setVerificationShow(false)}
        aria-labelledby="video-lg"
      >
        <Modal.Body className="p-0">
          <div
            onClick={() => setVerificationShow(false)}
            aria-label="delete"
            size="small"
            className="position-absolute top-0 end-0 btn-out"
          >
            <CloseIcon fontSize="small" className="text-white" />
          </div>
          <div className=" m-5">
            <div className="row">
              <div className="col-12">
                <Card
                  variant="outlined"
                  sx={{
                    // border: "gray",
                    borderRadius: 2,
                    borderWidth: 2,
                    p: 1,

                    borderColor: "primary.main",
                    boxShadow: 3,
                    transition: "0.2s",
                    flexGrow: 1,
                  }}
                >
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: "bold",
                      color: "#0873bb",
                      mb: 0.3,
                      textTransform: "uppercase",
                    }}
                  >
                    {productDetails?.dealerName}
                  </Typography>

                  <Typography sx={{ mb: 0.3, fontSize: "12px" }}>
                    <strong>Address:</strong> {productDetails?.dealerAddress}
                  </Typography>
                  <Typography sx={{ mb: 0.3, fontSize: "12px" }}>
                    <strong>Phone:</strong> {productDetails?.phone}
                  </Typography>
                  <Typography sx={{ mb: 0.3, fontSize: "12px" }}>
                    <strong>Email:</strong> {productDetails?.email}
                  </Typography>
                </Card>
              </div>
              <div className="col-12 txtdgray text-center py-4">
                {otpverificationresponse}
              </div>
              <div className="col-12 d-flex justify-content-center mt-2">
                <div
                  className="hivalueplussectionBtn d-flex justify-content-center align-items-center p-2"
                  style={{ width: "120px" }}
                  onClick={() => {
                    setVerificationShow(false);
                  }}
                >
                  OK
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <HIFotterMain />
    </>
  );
};

export default HIValueProductDetails;
